
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.19 10.5a9.19 9.19 0 11-18.38 0 9.19 9.19 0 0118.38 0z","fill":"#222F5A"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20 10.5c0 5.523-4.477 10-10 10s-10-4.477-10-10S4.477.5 10 .5s10 4.477 10 10zm-10 9.19a9.19 9.19 0 100-18.38 9.19 9.19 0 100 18.38z","fill":"#fff"}}),_c('path',{attrs:{"d":"M9.827 9.332c-.008.58.568.904 1.001 1.096.446.198.596.324.594.501-.003.27-.355.389-.685.394-.575.009-.91-.14-1.175-.254l-.208.884c.267.112.761.21 1.273.214 1.204 0 1.99-.54 1.993-1.38.005-1.063-1.615-1.122-1.604-1.597.004-.144.155-.298.486-.337.387-.034.777.029 1.128.18l.201-.854A3.342 3.342 0 0011.761 8c-1.132 0-1.928.548-1.934 1.332zm4.938-1.258a.558.558 0 00-.294.08.487.487 0 00-.193.215l-1.717 3.735h1.203l.239-.6h1.468l.139.6h1.057l-.925-4.03h-.977zm.168 1.089l.347 1.513h-.95l.603-1.513zM8.37 8.073l-.947 4.03h1.145l.946-4.03H8.37zm-1.693 0l-1.192 2.744-.482-2.333a.523.523 0 00-.528-.41H2.527L2.5 8.19c.4.079.854.206 1.13.342.168.084.216.157.271.354l.913 3.217h1.21l1.855-4.03H6.675","fill":"#fff"}})])
          )
        }
      }
    